import { render, staticRenderFns } from "./ArquivosGrupo.vue?vue&type=template&id=a2cee8c0&"
import script from "./ArquivosGrupo.vue?vue&type=script&lang=js&"
export * from "./ArquivosGrupo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports